__turbopack_context__.v({
  "blogCaruContainer": "BlogsHomeNew-module-scss-module__ACjL6q__blogCaruContainer",
  "blogsCarouselWrapper": "BlogsHomeNew-module-scss-module__ACjL6q__blogsCarouselWrapper",
  "blogsOnlineContainer": "BlogsHomeNew-module-scss-module__ACjL6q__blogsOnlineContainer",
  "blogsOnlineDesc": "BlogsHomeNew-module-scss-module__ACjL6q__blogsOnlineDesc",
  "blogsOnlineItem": "BlogsHomeNew-module-scss-module__ACjL6q__blogsOnlineItem",
  "blogsOnlineTitle": "BlogsHomeNew-module-scss-module__ACjL6q__blogsOnlineTitle",
  "bulletsContainer": "BlogsHomeNew-module-scss-module__ACjL6q__bulletsContainer",
  "cardImg": "BlogsHomeNew-module-scss-module__ACjL6q__cardImg",
  "content": "BlogsHomeNew-module-scss-module__ACjL6q__content",
  "ctaBtn": "BlogsHomeNew-module-scss-module__ACjL6q__ctaBtn",
  "ctaContainer": "BlogsHomeNew-module-scss-module__ACjL6q__ctaContainer",
  "date": "BlogsHomeNew-module-scss-module__ACjL6q__date",
  "heading": "BlogsHomeNew-module-scss-module__ACjL6q__heading",
  "nextArrow": "BlogsHomeNew-module-scss-module__ACjL6q__nextArrow",
  "prevArrow": "BlogsHomeNew-module-scss-module__ACjL6q__prevArrow",
  "slideWrapper": "BlogsHomeNew-module-scss-module__ACjL6q__slideWrapper",
});
